module.exports = __webpack_public_path__ + "img/home_djyq@2x.5ad51276.png";